/**
 * Заметки под блоками вопросов клиентов и причин отказа (#843, #844):
 * неполный счёт, что такое N, чем формулировки не являются.
 */
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import type { VoiceCustomerQuestions } from '@aica/api-types/schemas';
import { useVoiceComparable } from './voice-theme-filter-context';

/** Неполный счёт и что такое N — под блоками, как у остальных вкладок. */
export function VoiceQuestionsNotes({
  cq,
  children,
}: {
  cq: VoiceCustomerQuestions;
  children?: ReactNode;
}) {
  const { t } = useTranslation('dashboard');
  // The previous window of a theme set inside it was not read (#2229).
  const comparable = useVoiceComparable();
  return (
    <div className="space-y-1 text-xs text-fg-muted">
      {cq.truncated && <p>{t('voicePage.truncated')}</p>}
      {comparable && cq.prevTruncated && <p>{t('voicePage.prevTruncated')}</p>}
      {children}
      <p>{t('voicePage.questions.wordingNote')}</p>
    </div>
  );
}
